export const actionTypes = {
	SetUsers: '[Users] SetUsers',
	SetSpecialUsers: '[Users] SetSpecialUsers',
	UpdateFilter: '[Users] UpdateFilter',
	GetUsersOverview: '[Users] GetUsersOverview',
	UpdateLoading: '[Users] UpdateLoading',
};

export const initialUsers = {
	filter: {},
	usersOverview: {},
	mostActive: [],
	mostPopular: [],
	adminUsers: [],
	adminExpertUsers: [],
	adminExpertPendingUsers: [],
	loading: true,
};

export const reducer = (state = initialUsers, { type, payload }) => {
	switch (type) {
		case actionTypes.SetUsers:
			return {
				...state,
				mostActive: payload.mostActive.users,
				mostPopular: payload.mostPopular,
				loading: false,
			};
		case actionTypes.SetSpecialUsers:
			return {
				...state,
				adminUsers: payload.adminUsers,
				adminExpertUsers: payload.adminExpertUsers,
				adminExpertPendingUsers: payload.adminExpertPendingUsers,
				loading: false,
			};
		case actionTypes.UpdateFilter:
			return {
				...state,
				filter: payload,
			};
		case actionTypes.GetUsersOverview:
			return {
				...state,
				usersOverview: payload,
			};
		case actionTypes.UpdateLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

export const actions = {
	setUsers: (payload) => ({ type: actionTypes.SetUsers, payload }),
	getUsersOverview: (payload) => ({ type: actionTypes.GetUsersOverview, payload }),
	setSpecialUsers: (payload) => ({ type: actionTypes.SetSpecialUsers, payload }),
	updateFilter: (payload) => ({ type: actionTypes.UpdateFilter, payload }),
	updateLoading: (payload) => ({ type: actionTypes.UpdateLoading, payload }),
};

export function* saga() {}
